import { DocketNumber } from './DocketNumber';
import { ConstructEmptyExtendedFilingDetail, ExtendedFilingDetail } from './ExtendedFilingDetail';

export interface Filing {
  id?: number;
  agencyId: number;
  titleId: number;
  chapterId?: number;
  filingFormId: number;
  filingActionId: number;
  docketNumberId: number | null;
  filingName: string;
  createdBy: string;
  filedOn?: Date;
  effectiveOn?: Date;
  expiresOn?: Date;
  hearingDate?: Date;
  publicationDate?: Date;
  actionDate?: Date;
  lastUpdatedOn?: Date;
  filingDetail?: ExtendedFilingDetail;
  docketNumberDto?: DocketNumber;
  workflowId?: number;
  workflowStatusId?: number;
  filingFormName?: string;
  titleNumber?: number;
  titleName?: string;
  agencyName?: any;
  associatedChapters?: any[];
  createdOn?: Date;
  filingRejectReasonId?: number;

  // this is for table interaction don't pass it back to the api
  expanded?: boolean;
}

export const ConstructFilingTableTemplate = () => {
  let filing : Filing = {
    id: -1,
    agencyId: -1,
    titleId: -1,
    chapterId: -1,
    filingFormId: -1,
    filingActionId: -1,
    docketNumberId: -1,
    filingName: '',
    createdBy: '',
    filedOn: new Date(),
    effectiveOn: new Date(),
    expiresOn: new Date(),
    hearingDate: new Date(),
    publicationDate: new Date(),
    actionDate: new Date(),
    lastUpdatedOn: new Date(),
    filingDetail: ConstructEmptyExtendedFilingDetail(),
  };
  return filing;
}
